import { Box, Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography, useTheme } from '@mui/material'
import { useDealData } from 'api/aws/deals/useDealData'
import NoDataDefault from 'components/ui/no-data-default'
import { useLayoutContext } from 'context/LayoutProvider/LayoutProvider'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { BoxScroller } from 'styles/elements/styleElements'
import useTotals from '../../api/customHooks/useTotals'
import { tableCellStyles, tableHeaderStyles } from '../DealApproval/style'
import { downloadContract } from '../Deals/contracts/downloadContract'
import { formatCurrency } from '../DealsKanban/aggregateStageTotals'
import RenderServiceIcon from '../RenderServiceIcons/RenderServiceIcon'
import { calculateAccountingSchedule } from './calculateAccountingSchedule'
import IOTotalSchedule from './IOTotalSchedule'
import PandaDocViewer from './PandDocViewer'

interface AccountingScheduleProps {
  containerHeight?: any
  hideViewIcon?: any
}

const AccountingSchedule = ({ containerHeight, hideViewIcon }: AccountingScheduleProps) => {
  const { PK, SK } = useParams()
  const dealId = SK?.split?.('DEAL_')?.[1]
  const { pinned } = useLayoutContext()
  // const { deal, isLoading, isError } = useDeal(dealId)
  const { deal, productRows } = useDealData(PK, SK, dealId)
  // const deal = deals?.find(d => d?.SK === SK)
  // const products = allProducts?.filter(p => p?.PK === PK)
  // const productRows = products?.filter(p => p?.deal_uuid === deal?.deal_uuid)
  const totals = useTotals(productRows, deal?.implementationFee || 0, deal?.type ?? '')
  const [isDownloading, setIsDownloading] = useState(false)
  const theme = useTheme()

  useEffect(() => {
    if (deal) console.log('[AccountingSchedule] Deal: ', deal)
  }, [deal])
  useEffect(() => {
    if (productRows) {
      console.log('productRows', productRows)
    }
  }, [productRows])
  let paymentSchedule = calculateAccountingSchedule(deal, productRows)
  // Sort the paymentSchedule array by startDate (only for non-CSA)
  if (!['CSA', 'RCSA'].includes(deal?.type ?? '')) {
    paymentSchedule = paymentSchedule.sort((a: any, b: any) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime())
  }
  const handleDownloadContract = async () => {
    setIsDownloading(true)
    try {
      await downloadContract(deal ? deal.contractId : null)
      setIsDownloading(false)
    } catch (e) {
      setIsDownloading(false)
      console.log('Error: ', e)
    }
  }
  useEffect(() => {
    if (paymentSchedule) console.log('[AccountingSchedule] paymentSchedule: ', paymentSchedule)
  }, [paymentSchedule])
  if (!productRows?.length) {
    return (
      <NoDataDefault defaultMessage={!productRows?.length ? 'Please complete contract for invoicing data' : null} />
    )
  }

  return (
    <BoxScroller
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start', // Align items to the top to prevent content from being cut off
        height: pinned ? 'calc(100vh - 185px)' : 'calc(100vh - 122px)', // Ensure the content fits within the viewport
        overflowY: 'auto', // Enable vertical scrolling if needed
        padding: 2, // Add some padding to prevent content from touching edges
      }}
    >
      {deal && deal.type && deal.type !== 'IO' ? (
        <Grid container spacing={1} sx={{ maxWidth: '80vw' }}>
          {deal && deal.status === 'Completed' && (
            <>
              <Box sx={{ display: hideViewIcon ? 'none' : 'flex', justifyContent: 'end' }}>
                <PandaDocViewer contractId={deal ? deal.contractId : null} />
              </Box>
            </>
          )}
          {paymentSchedule?.map((item: any, index: number) => {
            return (
              <Grid item xs={12} key={`${index} - ${item.paymentNumber || item.month}`}>
                <Table sx={{ marginBottom: 2 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell colSpan={2} sx={tableHeaderStyles}>
                        {item.startDate && item.endDate
                          ? `${item.startDate} - ${item.endDate}`
                          : `Payment ${item.paymentNumber}`}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {item.products.map((product, idx) => (
                      <TableRow key={`${index}-${idx}-${product.productName}`}>
                        <TableCell sx={tableCellStyles(theme)}>
                          {<RenderServiceIcon service={product.productName} />}
                        </TableCell>
                        <TableCell sx={{ ...tableCellStyles(theme) }}>
                          {
                            <Typography
                              sx={{
                                color:
                                  product?.payer === 'Client' ? theme.palette.text.warning : theme.palette.text.primary,
                              }}
                            >
                              {formatCurrency(product.paymentAmount)}
                            </Typography>
                          }
                        </TableCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell
                        sx={{
                          ...tableCellStyles(theme),
                          textAlign: 'right',
                          borderRight: 'none',
                        }}
                        colSpan={1}
                      >
                        Total:
                      </TableCell>
                      <TableCell
                        sx={{
                          ...tableCellStyles(theme),
                          color: 'rgb(50, 187, 130)',
                          borderLeft: 'none',
                        }}
                        colSpan={1}
                      >
                        {formatCurrency(item.totalAmount)}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Grid>
            )
          })}
        </Grid>
      ) : (
        <IOTotalSchedule deal={deal} totals={totals} hideViewIcon={hideViewIcon} />
      )}
    </BoxScroller>
  )
}

export default AccountingSchedule
